import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtExamTemplateList } from 'containers';
import { ExamTemplateMenu, MyPageTitle, MyPageTemplate } from 'components';

class CtExamTemplate extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <MyPageTemplate className="table">
        <MyPageTitle
          templatePage="templatePage"
          title={defineMessages(formatMessage({ id: 'AdminMenu_7', defaultMessage: '훈련 템플릿' }))}>
          <ExamTemplateMenu />
        </MyPageTitle>
        <CtExamTemplateList />
      </MyPageTemplate>
    );
  }
}

CtExamTemplate.propTypes = {};
CtExamTemplate.defaultProps = {};

export default injectIntl(CtExamTemplate);



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplate.js